<div class="padding15">
  <div class="flex-row"> <h2 >{{ 'All properties' | translate}}</h2>
    <div class="search-wrapper margin-left10 mr-t margin-right50">

    <input
      class="search-input"
      type="text"
      [ngModel]="searchFilter"
      (ngModelChange)="onChangeSearchInput($event)"
      placeholder="{{ 'Search properties' | translate }}"
    />
    <div
      class="icon-search font-size22"
      *ngIf="searchFilter === ''"
    ></div>
    <div
      class="icon-clear font-size22"
      *ngIf="searchFilter !== ''"
      (click)="onClear()"
    ></div>
  </div>
</div>
    <div class="margin-top50" *ngFor="let controller of controllers">
      <div class="flex-column margin-bottom10" style="max-height: 250px; align-content: flex-start;overflow-x: auto;">
        <span style="font-size: 20px; font-weight: bold; margin-bottom: 12px;">{{controller.name}}</span>
          <div class="margin-right30" *ngFor="let prop of controller.controllerProperties.$values
           | sortByName | searchByName: searchFilter" >
            <div>
              {{prop.name}} -> {{ prop.value }}
            </div>
          </div>
      </div>
    </div>
</div>
